'use client';

export default function BillingToggle({ value, onChange, monthlyLabel, quarterlyLabel, badgeText }) {
  return (
    <div className="relative">
      <div className="flex bg-[#6A3683]/40 rounded-lg p-1 gap-1">
        <button
          type="button"
          onClick={() => onChange('monthly')}
          className={`
            flex-1 py-2 px-4 rounded-md text-sm font-semibold transition-all
            ${value === 'monthly'
              ? 'bg-[#A45DE8] text-white shadow-md'
              : 'text-[#FBFBFE]/70 hover:text-[#FBFBFE]'
            }
          `}
          aria-label="Select monthly billing"
        >
          {monthlyLabel}
        </button>
        <div className="flex-1 relative">
        <button
          type="button"
          onClick={() => onChange('quarterly')}
          className={`
              w-full py-2 px-4 rounded-md text-sm font-semibold transition-all
            ${value === 'quarterly'
              ? 'bg-[#A45DE8] text-white shadow-md'
              : 'text-[#FBFBFE]/70 hover:text-[#FBFBFE]'
            }
          `}
          aria-label="Select quarterly billing"
        >
          {quarterlyLabel}
        </button>
          {/* Most Popular Badge - Top right angle of quarterly button, positioned outside */}
          {badgeText && (
            <div className="absolute -top-4 -right-2 bg-gradient-to-r from-[#FFD700] via-[#FFA500] to-[#FFD700] text-[#050316] px-2 py-1 rounded-full text-xs font-semibold z-10 whitespace-nowrap shadow-lg animate-wave">
              {badgeText}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
